// extracted by mini-css-extract-plugin
module.exports = {"hours_card":"HoursCard_hours_card__UPxMI","schedules":"HoursCard_schedules__2oZH6","dining_list_item":"HoursCard_dining_list_item__3yHy9","heading":"HoursCard_heading__1YLj5"};